export default "__VITE_ASSET__73301d44__"